import { useCallback, useState } from 'react';

import { useCurrentUser } from '../contexts/CurrentUserContext';
import { copyRefusal, setStandIn } from '../services/itemCopies';
import { normalizeId } from '../utils/ids';

/**
 * COPY TO… (KPR-1024): a copy made with it stands in for its original in its
 * copier's combined lists, or not — the copy's own switch, offered to the
 * person who made it (its owner; the API refuses anyone else). Moved out of
 * ItemActionsMenu as it stood (KPR-710), which is held to its file-size
 * baseline.
 */
export default function useStandInCopy({ item, saved, itemId, message, onItemUpdated, onRelated }) {
	const { user: currentUser } = useCurrentUser();
	const copiedFrom = item?.copiedFrom && typeof item.copiedFrom === 'object' ? item.copiedFrom : null;
	const ownCopy = Boolean(copiedFrom && currentUser && normalizeId(item?.owner) && normalizeId(item.owner) === normalizeId(currentUser._id));
	const [standInBusy, setStandInBusy] = useState(false);
	const toggleStandIn = useCallback(async () => {
		if (!copiedFrom || !saved) return;
		const next = copiedFrom.standIn !== true;
		setStandInBusy(true);
		try {
			const updated = await setStandIn(itemId, next);
			message.success(next
				? 'Your copy is shown instead of the original in combined lists.'
				: 'Combined lists show the original beside your copy again.');
			if (typeof onItemUpdated === 'function') onItemUpdated(updated);
			else if (typeof onRelated === 'function') onRelated();
		} catch (error) {
			message.error(copyRefusal(error, 'That could not be changed. Try again.'));
		} finally {
			setStandInBusy(false);
		}
	}, [copiedFrom, saved, itemId, message, onItemUpdated, onRelated]);
	return { copiedFrom, ownCopy, standInBusy, toggleStandIn };
}
